/**
* Creates a counter
* @module copyToClipboard
*/
import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'copyToClipboard';
export const CLICK_EVENT = 'click';
export const DEFAULTS = {
  container: '.js-copy-clipboard-wrapper',
  textToCopy: '.js-copy-clipboard-text',
  notify: 'false',
  activeClass: '',
};

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
const mergeOptions = ($el, options = {}) => {
  const opts = $.extend({}, DEFAULTS, $el.data(), options);
  return opts;
};
const copyToClipboardFunc = ($el, opts) => {
  const container = opts.container;
  const textContainer = opts.textToCopy;
  const textToCopy = $el.closest(container).find(textContainer);
  const el = textToCopy.get(0);
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    const editable = el.contentEditable;
    const readOnly = el.readOnly;
    el.contentEditable = true;
    el.readOnly = true;
    const range = document.createRange();
    range.selectNodeContents(el);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    if (el.type === 'email') {
      el.type = 'text';
    }
    el.setSelectionRange(0, 999999);
    el.contentEditable = editable;
    el.readOnly = readOnly;
  }
  textToCopy.select();
  document.execCommand('copy');
  textToCopy.blur();
  if (el.id === 'clipboard-copy-email-address') {
    el.type = 'email';
  }
};
const copyToClipboardNotification = ($el, opts) => {
  const activeClass = opts.activeClass;
  if (opts.notify === true) {
    $el.addClass(activeClass);
    const removeActive = () => {
      $el.removeClass(activeClass);
    };
    setTimeout(removeActive, 3000);
  }
};
 /**
 * Applies any sort of event handlers for the count incrementation.
 * @param {jQuery} $el - Containing the elements for the Counter
 * @param {Object} options - Options used for wiring up the Counter
 * @see DEFAULTS
 */
const applyEventHandlers = ($el, opts = {}) => {
  $el.on(CLICK_EVENT, () => {
    copyToClipboardFunc($el, opts);
    copyToClipboardNotification($el, opts);
  });
};
 /**
 * Initializes blank based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * Counter
 * @param {Object} options - Options used for wiring up the Count
 * @see DEFAULTS
 */
export default function copyToClipboard(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions($el, options);
  applyEventHandlers($el, opts);
}
 // Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, copyToClipboard);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/copy-clipboard.js